import { app } from '../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.sharing-center.shared-accounts', {
        url: '/shared-accounts',
        component: 'companySharingCenterSharedAccounts',
        resolve: {accounts},
    });
}

/** @ngInject */
function accounts($filter, companyId, UserAccounts) {
    return UserAccounts.getSharedEmailAccounts({companyId}, {}).$promise
        .then(items => $filter('orderBy')(items, 'publicService.serviceName'))
}



// WEBPACK FOOTER //
// ./src/portal/states/company/sharing-center/shared-accounts/shared-accounts.state.js